var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap pl8"},[_c('div',{staticClass:"wrap-label f13 f-grey"},[_vm._v(_vm._s(_vm.label))]),_c('el-switch',{model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }